import { AxiosError } from 'axios';
import { apiService } from '@/shared/services/apiServices';
import facilityEndpoints from './facilityEndpoints';
import { FACILITY_VIEW_ERROR_MESSAGES } from '../errors/errorMessages';
import type {
  ViewFacilityResponse,
  ViewFacilityResult,
} from '../types/viewFacilityTypes';

export const getFacility = async (
  facilityId: string
): Promise<ViewFacilityResult> => {
  try {
    const response = await apiService.getAPI(
      facilityEndpoints.FACILITY_GET(facilityId.trim())
    );
    if (!response.error && response.data) {
      return { success: true, data: response.data as ViewFacilityResponse };
    }
    return {
      success: false,
      error: FACILITY_VIEW_ERROR_MESSAGES.DEFAULT_ERROR,
    };
  } catch (err) {
    if (err instanceof AxiosError && !err.response) {
      return {
        success: false,
        error: FACILITY_VIEW_ERROR_MESSAGES.NETWORK_ERROR,
      };
    }
    return {
      success: false,
      error: FACILITY_VIEW_ERROR_MESSAGES.UNEXPECTED_ERROR,
    };
  }
};
